class GiftQuantity extends QuantityInput {
  constructor() {
    super();
  }

  init() {
    super.init();

    this.giftWrapping = document.querySelector('gift-wrapping');
    this.cartItemsSize = parseInt(this.getAttribute('cart-items-size'));
    this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart'));
    this.itemsInCart = (theme.shopSettings.giftwrapRate == 'flat') ? 1 : parseInt(this.getAttribute('items-in-cart'));

    // If we have nothing but gift-wrap items in the cart.
    if (this.cartItemsSize == 1 && this.giftWrapsInCart > 0) {
      this.giftWrapping.removeGiftWrap();
    }
    // If we don't have the right amount of gift-wrap items in the cart.
    else if (this.giftWrapsInCart > 0 & this.giftWrapsInCart != this.itemsInCart) {
      this.update();
    }
    // If we have a gift-wrap item in the cart but our gift-wrapping cart attribute has not been set.
    else if (this.giftWrapsInCart > 0 && this.giftWrapping.length == 0) {
      this.update();
    }
    // If we have no gift-wrap item in the cart but our gift-wrapping cart attribute has been set.
    else if (this.giftWrapsInCart == 0 && this.giftWrapping.length > 0) {
      this.update();
    }
  }

  update() {
    this.input.value = this.itemsInCart;
    this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('gift-quantity', GiftQuantity);

class GiftWrapping extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');
    this.giftWrapId = this.dataset.giftWrapId;
    this.giftWrapping = this.dataset.giftWrapping;
    this.cartItemsSize = parseInt(this.getAttribute('cart-items-size'));
    this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart'));
    this.itemsInCart = (theme.shopSettings.giftwrapRate == 'flat') ? 1 : parseInt(this.getAttribute('items-in-cart'));

    // When the gift-wrapping checkbox is checked or unchecked.
    this.querySelector('[name="attributes[gift-wrapping]"]').addEventListener("change", (event) => {
      event.target.checked ? this.setGiftWrap() : this.removeGiftWrap();
    });

    if (this.miniCart) return;

    // If we have nothing but gift-wrap items in the cart.
    if (this.cartItemsSize == 1 && this.giftWrapsInCart > 0) {
      this.removeGiftWrap();
    }
    // If we don't have the right amount of gift-wrap items in the cart.
    else if (this.giftWrapsInCart > 0 & this.giftWrapsInCart != this.itemsInCart) {
      this.setGiftWrap();
    }
    // If we have a gift-wrap item in the cart but our gift-wrapping cart attribute has not been set.
    else if (this.giftWrapsInCart > 0 && this.giftWrapping.length == 0) {
      this.setGiftWrap();
    }
    // If we have no gift-wrap item in the cart but our gift-wrapping cart attribute has been set.
    else if (this.giftWrapsInCart == 0 && this.giftWrapping.length > 0) {
      this.setGiftWrap();
    }
  }

  setGiftWrap() {
    const loadingOverlay = this.querySelector('.loading-overlay');
    loadingOverlay.classList.remove('hidden');

    const sections = this.getSectionsToRender().map((section) => section.section);
    const body = JSON.stringify({
      updates: {
        [this.giftWrapId]: this.itemsInCart
      },
      attributes: {
        'gift-wrapping': true
      },
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => response.json())
      .then((response) => {
        loadingOverlay.classList.add('hidden');

        if (document.body.classList.contains('template-cart')) {
          window.location.href = theme.routes.cart_url;
          return;
        }

        this.miniCart && this.miniCart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  removeGiftWrap() {
    const loadingOverlay = this.querySelector('.loading-overlay');
    loadingOverlay.classList.remove('hidden');

    const sections = this.getSectionsToRender().map((section) => section.section);
    const body = JSON.stringify({
      updates: {
        [this.giftWrapId]: 0
      },
      attributes: {
        'gift-wrapping': '',
        'gift-note': ''
      },
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => response.json())
      .then((response) => {
        loadingOverlay.classList.add('hidden');
        
        if (document.body.classList.contains('template-cart')) {
          window.location.href = theme.routes.cart_url;
          return;
        }

        this.miniCart && this.miniCart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];
  }
}
customElements.define('gift-wrapping', GiftWrapping);

class GiftNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ attributes: { 'gift-note': event.target.value } });
      fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300));
  }
}
customElements.define('gift-note', GiftNote);


// Gift wrap offer (2026-09-10, replaces the Wrapin app). One wrap line per click, message as a line property.
// 2026-09-29: errors are shown, a typed note and chosen style survive cart/drawer re-renders, a drawer add
// re-opens the popup with the confirmation, and the Theme settings > Gift wrap options (dropdown, required
// message, character count) are handled here.
const giftWrapDrafts = {};

class GiftWrapOffer extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');
    this.context = this.dataset.context;
    this.button = this.querySelector('.gift-wrap-offer__button');
    this.status = this.querySelector('.gift-wrap-offer__status');
    this.noteField = this.querySelector('textarea');
    this.select = this.querySelector('select');
    this.count = this.querySelector('.gift-wrap-offer__count');

    this.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        this.markSelected(radio);
        this.saveDraft();
      });
    });
    if (this.select) this.select.addEventListener('change', () => this.saveDraft());
    if (this.noteField) {
      this.noteField.addEventListener('input', () => {
        this.updateCount();
        this.saveDraft();
      });
    }
    this.button.addEventListener('click', () => this.addGiftWrap());

    this.restoreDraft();
  }

  selectedVariant() {
    if (this.select) return this.select.value;
    const radio = this.querySelector('input[type="radio"]:checked');
    return radio ? radio.value : null;
  }

  markSelected(radio) {
    this.querySelectorAll('.gift-wrapping__style').forEach((label) => label.classList.toggle('is-selected', label.contains(radio)));
  }

  updateCount() {
    if (this.count && this.noteField) this.count.textContent = `${this.noteField.value.length}/${this.noteField.maxLength}`;
  }

  saveDraft() {
    giftWrapDrafts[this.context] = { note: this.noteField ? this.noteField.value : '', variant: this.selectedVariant() };
  }

  restoreDraft() {
    const draft = giftWrapDrafts[this.context];
    if (!draft) return;
    if (this.noteField) this.noteField.value = draft.note;
    this.updateCount();
    if (!draft.variant) return;
    if (this.select) {
      if (this.select.querySelector(`option[value="${draft.variant}"]`)) this.select.value = draft.variant;
      return;
    }
    const radio = this.querySelector(`input[type="radio"][value="${draft.variant}"]`);
    if (radio) {
      radio.checked = true;
      this.markSelected(radio);
    }
  }

  setBusy(busy) {
    if (busy) {
      this.button.setAttribute('disabled', '');
      this.button.classList.add('loading');
    } else {
      this.button.removeAttribute('disabled');
      this.button.classList.remove('loading');
    }
  }

  showStatus(text, isError) {
    this.status.textContent = text;
    this.status.classList.toggle('is-error', isError);
    this.status.hidden = false;
  }

  addGiftWrap() {
    const variantId = this.selectedVariant();
    if (!variantId) return;

    const note = this.noteField ? this.noteField.value.trim() : '';
    if (this.noteField && this.noteField.hasAttribute('data-required') && !note) {
      this.showStatus(this.dataset.requiredText, true);
      this.noteField.focus();
      return;
    }

    const properties = {};
    if (note) properties['Gift Note'] = note;
    if (this.dataset.productTitle) properties['Product Name'] = this.dataset.productTitle;
    const sections = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble', 'cart-live-region-text'];

    this.setBusy(true);
    this.status.hidden = true;

    fetch(`${theme.routes.cart_add_url}`, {...fetchConfig(), ...{ body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: properties }], sections: sections.join(','), sections_url: window.location.pathname }) }})
      .then((response) => response.json())
      .then((response) => {
        if (response.status || !Array.isArray(response.items)) throw new Error(response.description || response.message || 'Gift wrap could not be added');
        delete giftWrapDrafts[this.context];

        if (this.context === 'cart') {
          window.location.href = theme.routes.cart_url;
          return;
        }

        this.setBusy(false);
        if (this.noteField) this.noteField.value = '';
        this.updateCount();
        this.showStatus(this.dataset.addedText, false);
        if (!this.miniCart || !response.sections) return;

        // The drawer is re-rendered, so the confirmation is shown on the new panel (its popup re-opened).
        try {
          this.miniCart.renderContents(response);
        } catch (e) {
          console.error(e);
          return;
        }
        const list = document.querySelector('#mini-cart .mini-cart__main');
        if (list) list.scrollTop = 0;
        if (this.context === 'drawer') {
          const offer = document.querySelector('#mini-cart gift-wrap-offer');
          const popup = offer && offer.closest('details');
          if (popup) popup.setAttribute('open', '');
          if (offer && offer.showStatus) offer.showStatus(this.dataset.addedText, false);
        }
      })
      .catch((e) => {
        console.error(e);
        this.setBusy(false);
        this.showStatus(this.dataset.errorText, true);
      });
  }
}
customElements.define('gift-wrap-offer', GiftWrapOffer);
